import { giphyBlue, giphyGreen, giphyPurple, giphyRed, giphyYellow } from '@giphy/js-brand'
import styled, { css, keyframes } from 'styled-components'
import { LoaderSize } from '../types'
import { borderRadiusFromLoaderSize, heightFromLoaderSize } from '../utils'

const blockAnimation = keyframes`
    0% { transform: scale(1) translateY(90%); }
    100% { transform: scale(1.75) translateY(-85%); }
`

export const Block = styled.div`
    animation: ${blockAnimation} cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s infinite alternate backwards;
    flex-shrink: 0;

    &:nth-child(1) {
        background: ${giphyGreen};
    }

    &:nth-child(2) {
        animation-delay: 0.1s;
        background: ${giphyBlue};
    }

    &:nth-child(3) {
        animation-delay: 0.2s;
        background: ${giphyPurple};
    }

    &:nth-child(4) {
        animation-delay: 0.3s;
        background: ${giphyRed};
    }

    &:nth-child(5) {
        animation-delay: 0.4s;
        background: ${giphyYellow};
        margin-right: 0;
    }
`

export const Container = styled.div<{ loaderSize: LoaderSize }>`
    align-items: center;
    display: flex;
    justify-content: center;

    ${({ loaderSize }) => {
        const size = heightFromLoaderSize(loaderSize)

        return css`
            ${Block} {
                border-radius: ${borderRadiusFromLoaderSize(loaderSize)}px;
                height: ${size}px;
                margin-right: ${size}px;
                margin-top: ${size}px;
                width: ${size}px;
            }
        `
    }}
`
